import { Link, useNavigate } from 'react-router-dom';
import p_nav_previous from '../../Assets/Images/p_nav_previous.svg';
import { FaArrowRight } from "react-icons/fa6";
import { IoQrCodeOutline } from "react-icons/io5";
import { useEffect, useRef, useState } from 'react';
import Scanner from '../../Components/Scanner';
import Lottie from "lottie-react";
import Qr_cam from "../../Assets/lottieFiles/Qr_cam.json"
import { FiZap } from "react-icons/fi";
import { showToast } from '../../Components/toastConfig/ToastConfig';

const QRCodeScan = () => {

    const navigate = useNavigate();
    const [torchOn, setTorchOn] = useState(false);

    const toggleTorch = async () => {
        const video = document.querySelector("video");
        const stream = video?.srcObject;
        const track = stream?.getVideoTracks?.()[0];

        if (track && track.getCapabilities) {
            const capabilities = track.getCapabilities();
            if (capabilities.torch) {
                try {
                    await track.applyConstraints({
                        advanced: [{ torch: !torchOn }],
                    });
                    setTorchOn(!torchOn);
                } catch (error) {
                    console.error("Torch toggle error:", error);
                }
            } else {
                showToast("Torch not supported on this device");
            }
        }
    };

    return (
        <>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                    <img src={p_nav_previous} width={'24px'} height={'16px'} alt='Previous Button' role='button' onClick={() => navigate(-1)} />
                    <div className='ff-balooPaaji2-bold fs-20 ms-2 ps-1'>QR Code Scan</div>
                </div>
            </div>

            <div className='d-flex flex-column justify-content-between scroller-style-y'>
                <div className='ff-poppins-regular d-flex flex-column justify-content-center align-items-center h-25 px-3'>
                    Scan the QR Code to find the merchant
                </div>
                {/* <div className='position-relative ' >

                    <div className='  secondary-bg'>
                        <Scanner style={{ width: '100%', height: '126%' }} />
                    </div>

                    <div className='position-absolute top-50 start-50 translate-middle' style={{ zIndex: 10, width: '80%', height: '100%' }}  >
                        <Lottie animationData={Qr_cam} />
                    </div> 
                </div> */}

                <div className="position-relative" style={{ width: "100%", height: "100vh" }}>
                    <div className="secondary-bg" style={{ width: "100%", height: "100%" }}>
                        <Scanner style={{ width: "100%", height: "100%" }} />
                    </div>

                    {/* <div
                        className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                        style={{ zIndex: 10 }}
                    >
                        <Lottie animationData={Qr_cam} style={{ width: "150px", height: "150px" }} />
                    </div> */}
                </div>



                <div className='d-flex flex-column justify-content-center align-items-center mx-3 h-25'>
                    <div className='ff-poppins-regular d-flex '>
                        <span>
                            If code can not be scanned, please enter the Merchant ID to proceed.
                        </span>
                        <span className='mx-3 d-flex flex-column justify-content-center align-items-center'>
                            <Link to={'/SearchMerchant'} className='text-black'> <FaArrowRight className='fs-2' /> </Link>
                        </span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default QRCodeScan;